import { Injectable } from '@angular/core';
import { ClientReceivedDocumentDto } from '../dtos/client-received-document.dto';
import { ClientReceivedDocument } from '../../domain/models/client-received-document.model';

// Maps the backend's `Document.Source` enum to the domain union. `PatientUpload` should never
// occur on this endpoint, so it falls back to `'chat'` -- the sole source this feature knew before
// direct uploads were introduced -- alongside any other unrecognized value.
const DOCUMENT_SOURCE_MAP: Readonly<Record<string, ClientReceivedDocument['source']>> = {
  ChatAttachment: 'chat',
  ClientDirectUpload: 'direct',
};

@Injectable()
export class ClientReceivedDocumentMapper {
  public toClientReceivedDocument(dto: ClientReceivedDocumentDto): ClientReceivedDocument {
    return {
      id: dto.Id,
      publicId: dto.PublicId,
      fileName: dto.FileName,
      contentType: dto.ContentType,
      sizeBytes: dto.SizeBytes,
      sentAtUtc: dto.SentAtUtc,
      source: DOCUMENT_SOURCE_MAP[dto.Source] ?? 'chat',
    };
  }
}
